// extracted by mini-css-extract-plugin
export var videoHero = "_dq-4";
export var videoHeroImage = "_dq-5";
export var videoHeroOverlay = "_dq-6";
export var videoHeroSubtitle = "_dq-8";
export var videoHeroText = "_dq-7";
export var videoLauncher = "_dq-0";
export var videoLauncherIcon = "_dq-1";
export var videoLauncherSubtitle = "_dq-3";
export var videoLauncherTitle = "_dq-2";
export var videoPlayer = "_dq-a";
export var videoPlayerWrap = "_dq-9";